import RelatedArticles from "./RelatedArticles";
import type { RelatedArticlesProps } from "./RelatedArticles.d";

export default RelatedArticles;
export type { RelatedArticlesProps };
